export default __webpack_public_path__ + "static/media/see-homes.e6884f39.png";